import { Component } from '@angular/core';

@Component({
  selector: 'tx-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.scss'],
})
export class SiteComponent {}
